import { useLazyQuery } from "@apollo/client/react";
import { useCallback, useEffect, useState } from "react";
import { adaptDelegacionWithoutAllArray } from "../../../adapters/delegacionAdapter";
import { adaptConsultasGeneralesArray, GET_CONSULTAS } from "../../../data/graphQL/queries/ConsultasGenerales/getConsultasGenerales";
import { GET_DELEGACIONES_BY_USUARIO } from "../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario";

const storageId = sessionStorage.getItem('idUsuario');

const initialFilters = {
};

export const useGetFilters = () => {

    const [filters, setFilters] = useState(initialFilters);
    const [delegaciones, setDelegaciones] = useState([]);
    const [consultasOptions, setConsultasOptions] = useState([]);

    const [getDelegaciones, { data: dataDelegaciones, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO);
    const [getConsultas] = useLazyQuery(GET_CONSULTAS, {
        fetchPolicy: 'no-cache'
    });

    const handleChangeFilters = useCallback((name, value) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    }, []);

    useEffect(() => {
        getConsultas()
            .then(({ data }) => {
                const adaptedConsultas = adaptConsultasGeneralesArray(data?.consultas?.valorEsperado || []);
                setConsultasOptions(adaptedConsultas);
            });
    }, []);

    useEffect(() => {
        getDelegaciones({ variables: { idUsuario: JSON.parse(storageId, 10) } });
    }, []);

    useEffect(() => {
        if (!dataDelegaciones) return;
        setDelegaciones(adaptDelegacionWithoutAllArray(dataDelegaciones));
    }, [dataDelegaciones]);

    return {
        filters,
        handleChangeFilters,
        delegaciones,
        delegacionesLoading,
        consultasOptions
    };
};
